<template>
  <v-container>
    <v-row>
      <MobileCol>
        <v-card
          class="mx-auto"
          :loading="isLoading"
        >
          <div class="text-center" v-if="!isLoading">
            <!-- <VueQrcode value="url" style="width: 164px" /> -->
            <v-img
              :src="qrCodeUrl"
              style="margin-left: auto; margin-right: auto; width: 164px"
            />
          </div>
          <v-card-title v-if="client">
            {{ client.initials }} {{ client.surname }}
            <span class="float-right ml-2">({{ client.contractCode }})</span>
          </v-card-title>
          <v-card-text>
             <v-list subheader>
               <v-subheader>{{ $$t('subheader') }}</v-subheader>
               <div v-for="familyMember in familyMembers" :key="familyMember.id">
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ familyMember.name }} {{ familyMember.surname }}
                    <v-btn class="float-right" x-small color="error" @click="remove(familyMember)">
                      {{ $t('common.buttons.delete') }}
                    </v-btn>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                </div>
            </v-list>

            <v-divider></v-divider>

          </v-card-text>
          <v-card-actions>
            <v-btn block color="primary" @click="dialog = true">
              <v-icon class="mr-2">{{ mdiPlus }}</v-icon>
              {{ $$t('add')}}
            </v-btn>
          </v-card-actions>
          <v-card-actions>
            <v-btn
              block
              color="primary"
              target="_blank"
              :href="pdfLink"
            >
              <v-icon class="mr-2">{{ mdiFilePdfOutline }}</v-icon>
              {{ $$t('exportPdf') }}
            </v-btn>
          </v-card-actions>
          <v-card-actions>
            <v-btn
              block
              color="primary"
              @click="emailPdf"
              :loading="isEmailing"
            >
              <v-icon class="mr-2">{{ mdiEmail }}</v-icon>
              {{ $$t('emailPdf') }}
            </v-btn>
          </v-card-actions>
          <v-card-actions>
            <back-button />
          </v-card-actions>
        </v-card>
      </MobileCol>
    </v-row>
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title>
          {{ $$t('add')}}
        </v-card-title>

        <v-card-text>
          <form-family-member
            :FamilyMember="editFamilyMember"
            @cancel="dialog = false"
            @save="saveFamilyMember"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios';
// import VueQrcode from 'vue-qrcode';
import { mapActions, mapState } from 'vuex';
import {
  mdiDelete, mdiEmail, mdiFilePdfOutline, mdiPlus,
} from '@mdi/js';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import org from '@codehq/aurora-app-core/src/mixins/org';
import MobileCol from '../components/MobileCol.vue';
import FormFamilyMember from '../components/FormFamilyMember.vue';
import BackButton from '../components/BackButton.vue';

export default {
  name: 'MembershipHome',
  module: 'Membership',
  components: {
    MobileCol,
    // VueQrcode,
    FormFamilyMember,
    BackButton,
  },
  mixins: [loading, org],
  data() {
    return {
      mdiDelete,
      mdiEmail,
      mdiFilePdfOutline,
      mdiPlus,
      dialog: false,
      editFamilyMember: undefined,
      isDownloading: false,
      isEmailing: false,
    };
  },
  computed: {
    ...mapState('auth', ['username', 'userId']),
    ...mapState('organizations', ['organization']),
    ...mapState('clients', ['clients']),
    ...mapState('familyMembers', ['familyMembers']),
    ...mapState('profiles', ['profiles']),
    client() {
      return this.clients[0] ?? undefined;
    },
    defaultFamilyMember() {
      return {
        username: this.username,
        name: '',
        surname: '',
      };
    },
    pdfLink() {
      return `${process.env.VUE_APP_APIURL}/export/card/${this.organization?.id}/${this.userId}`;
    },
    emailPdfLink() {
      return `${process.env.VUE_APP_APIURL}/export/email/${this.organization?.id}`;
    },
    url() {
      return `${process.env.VUE_APP_APPURL}/user/${this.client?.id}`;
    },
    qrCodeUrl() {
      return `${process.env.VUE_APP_APIURL}/export/qrcode/${this.userId}`;
    },
  },
  created() {
    this.editFamilyMember = { ...this.defaultFamilyMember };
  },
  async mounted() {
    await this.refresh();
  },
  methods: {
    ...mapActions('clients', ['LOAD_clients']),
    ...mapActions('familyMembers', ['LOAD_familyMembers', 'CREATE_familyMember', 'DELETE_familyMember']),
    ...mapActions('profiles', ['LOAD_profiles']),
    // async download() {
    //   try {
    //     this.isDownloading = true;
    //     const response = await axios({
    //       headers: {
    //         OrganizationId: `${this.organization.id}`,
    //       },
    //       url: this.pdfLink,
    //       method: 'GET',
    //       responseType: 'blob', // important
    //     });
    //     const url = window.URL.createObjectURL(new Blob([response.data]));
    //     const link = document.createElement('a');
    //     link.href = url;
    //     link.setAttribute('download', 'Suidlanders.pdf');
    //     document.body.appendChild(link);
    //     link.click();
    //   } catch (error) {
    //     this.$log.error(error);
    //   } finally {
    //     this.isDownloading = false;
    //   }
    // },
    async emailPdf() {
      try {
        this.isEmailing = true;
        await axios.get(this.emailPdfLink);
        this.$root.$emit('toast:notify', this.$t('common.phrases.emailSent'));
      } catch (error) {
        this.$log.error(error);
      } finally {
        this.isEmailing = false;
      }
    },
    async refresh() {
      this.isLoading = true;
      await Promise.all([
        (async () => {
          await this.LOAD_clients();
        })(),
        (async () => {
          await this.LOAD_familyMembers();
        })(),
        (async () => {
          await this.LOAD_profiles();
        })(),
      ]);
      this.isLoading = false;
    },
    async remove(familyMember) {
      const result = await this.$confirm(this.$t('common.phrases.confirmDelete'));
      if (result) {
        this.isLoading = true;
        await this.DELETE_familyMember(familyMember.id);
        await this.LOAD_familyMembers();
        this.isLoading = false;
      }
    },
    async saveFamilyMember(familyMember) {
      this.isLoading = true;
      this.dialog = false;
      await this.CREATE_familyMember(familyMember);
      this.isLoading = false;
      this.editFamilyMember = { ...this.defaultFamilyMember };
    },
  },
};
</script>
